document.addEventListener(
  "DOMContentLoaded",
  () => {

    const heroes =
      document.querySelectorAll(
        ".editorial-hero-v3"
      );

    if (!heroes.length) return;

    heroes.forEach((hero) => {

      const image =
        hero.querySelector(
          ".editorial-hero-v3__image"
        );

      const badge =
        hero.querySelector(
          ".editorial-hero-v3__badge"
        );

      let currentGap = 120;
      let targetGap = 120;

      /*
      =====================================
      SCROLL GAP ANIMATION
      =====================================
      */

      function updateGap() {

        const rect =
          hero.getBoundingClientRect();

        const windowHeight =
          window.innerHeight;

        /*
        0 → entering viewport
        1 → fully passed
        */

        const progress =
          Math.max(
            0,
            Math.min(
              1,
              (
                windowHeight -
                rect.top
              ) /
              (
                windowHeight +
                rect.height
              )
            )
          );

        /*
        GAP RANGE
        */
const topGap =
  0 +
  progress * 240;

const bottomGap =
  80 +
  progress * 180;

hero.style.setProperty(
  "--hero-gap-top",
  `${topGap}px`
);

hero.style.setProperty(
  "--hero-gap-bottom",
  `${bottomGap}px`
);

        const contentGap =
  progress * 250;
hero.style.setProperty(
  "--hero-content-gap",
  `${contentGap}px`
);

      }

      /*
      =====================================
      SMOOTH GAP
      =====================================
      */

      function animate() {

        currentGap +=
          (
            targetGap -
            currentGap
          ) * 0.08;

        hero.style.setProperty(
          "--hero-gap",
          `${currentGap}px`
        );

        requestAnimationFrame(
          animate
        );

      }

      animate();

      updateGap();

      window.addEventListener(
        "scroll",
        updateGap,
        {
          passive: true
        }
      );

      window.addEventListener(
        "resize",
        updateGap
      );

      /*
      =====================================
      MOUSE PARALLAX
      =====================================
      */

      hero.addEventListener(
        "mousemove",
        (event) => {

          const rect =
            hero.getBoundingClientRect();

          const x =
            (
              event.clientX -
              rect.left
            ) /
            rect.width;

          const y =
            (
              event.clientY -
              rect.top
            ) /
            rect.height;

          const moveX =
            (x - 0.5) * 30;

          const moveY =
            (y - 0.5) * 30;

          if (image) {

            image.style.transform =
              `
              translate(
                calc(-50% + ${moveX * 0.3}px),
                calc(-50% + ${moveY * 0.3}px)
              )
              `;
          }

        

        }
      );

      /*
      =====================================
      RESET
      =====================================
      */

      hero.addEventListener(
        "mouseleave",
        () => {

          if (image) {

            image.style.transform =
              "translate(-50%, -50%)";
          }

         

        }
      );

    });

  }
);